import { FormFields } from '@orderform/widgets';
import { Observable } from 'rxjs';

export interface InterfaceField {
  index: number;
  field: FormFields.Field;
  show$: Observable<boolean>;
}

export interface InterfaceFields {
  fields: InterfaceField[];
}

export const FIELD_LIST_WITH_ON_BLUR_CHANGE = [
  'buyer_address_zipcode',
  'buyer_address_private_zipcode',
  'buyer_address_zipcode_billing',
  'buyer_address_private_zipcode_billing',
];

export const FIELD_LIST_WITH_UPDATE_TRIGGER = [
  'buyer_address_zipcode',
  'buyer_address_private_zipcode',
  'buyer_address_zipcode_billing',
  'buyer_address_private_zipcode_billing',
];
